export default {
  GatewayDeviceManagement: '网关实例管理',
  GatewayDevice: '网关设备',
  GatewayInformation: '网关信息',
  NetworkConfig: '网络配置',
  NATConfig: 'NAT配置',
  WANConfig: 'WAN口配置',
  LANConfig: 'LAN口配置',
  VLANConfig: 'VLAN配置',
  LoopBackConfig: 'LoopBack配置',
  DNSConfig: 'DNS配置',
  ADDConfig: '添加配置',
  DeleteConfirm: '确定删除该条配置？',
  AssociatedDevices: '关联设备',
  AssociatedDevicesPlaceholder: '请选择关联设备',
  ConnectionMode: '连接方式',
  VlanPortMode: '端口模式',
  VlanID: 'Vlan ID',
  LogicPort: '逻辑口',
  PhysicalPort: '物理口',
  AddVlanConf: '添加VLAN配置',
  AddLoopBackConf: '添加LoopBack配置',
  LogicPopover: (
    vlanCount: number = 0,
    loopbackCount: number = 0,
    vlanLimit: number = 0,
    loopbackLimit: number = 0
  ) => {
    const vlan = `已配置${vlanCount}条vlan配置`
    const loopback = `已配置${loopbackCount}条Loopback配置`
    const vlanlimit = vlanLimit
      ? vlanCount >= vlanLimit
        ? '，配置数量已达上限；'
        : `，最大配置数量${vlanLimit}条；`
      : '；'
    const loopbacklimit = loopbackLimit
      ? loopbackCount >= loopbackLimit
        ? '，配置数量已达上限；'
        : `，最大配置数量${loopbackLimit}条；`
      : '；'
    return `${vlan}${vlanlimit}${loopback}${loopbacklimit}`
  },
  DefaultVlanId: 'Default ID',
  DnsAddress1: 'DNS地址1',
  DnsAddress2: 'DNS地址2',
  ConnectionModePlaceholder: '请选择连接方式',
  WorkModePlaceholder: '请选择工作模式',
  VlanPortModePlaceholder: '请选择端口模式',
  VlanIDPlaceholder: '请填写1-4094范围的正整数',
  MultiVlanIDPlaceholder: '填写1-4094，多个逗号隔开，支持范围，如2,14-20',
  DefaultVlanIdPlaceholder: '默认为1，不能与VLAN ID重叠',
  DnsAddress1Placeholder: '请填写主DNS服务器地址（选填）',
  DnsAddress2Placeholder: '请填写备用DNS服务器地址（选填）',
  IPAddress: 'IP地址',
  Netmask: '掩码',
  Gateway: '网关',
  PortName: '端口名称',
  BranchIsRequire: '分支机构不能为空',
  IspsIsRequire: '运营商不能为空',
  CityIsRequire: '接入地点不能为空',
  BasicInfo: '基本信息',
  GatewayStatus: '网关状态',
  Accesspoint: '接入点',
  IspsPlaceholder: '请选择运营商',
  Branch: '分支机构',
  Save: '保存 ',
  LastTime: '最近启用时间',
  ActiveSuccess: '激活成功',
  Active: '激活',
  CpeSN: '设备号/License ID',
  CpeStatus: '设备状态',
  ActiveAt: '首次激活时间',
  OnlineAt: '最近上线时间',
  OfflineAt: '最近离线时间',
  ActiveCpe: '激活设备',
  CpeSN1: '设备1 SN号',
  CpeCheck: '设备校验',
  CpePlaceholder: '请输入设备SN号后六位',
  Priority: '优先级',
  Weight: '权重',
  WANIPPlaceholder: '请填写WAN口的IP地址',
  WANNetMaskPlaceholder: '请填写WAN口的IP地址掩码',
  WANGatewayPlaceholder: '请填写当前设备的网关IP地址',
  Account: '账号',
  Password: '密码',
  TotalCount: (count: number) => `共${count}项`,
  Add: '添加',
  NetworkName: '物理网卡',
  NetworkNameRequire: '请选择当前设备的物理网卡',
  PriorityHelp: '在多WAN口情况下，您可以为每个WAN口指定一个优先级，最高优先级端口为主端口',
  PriorityTips: '填写1~200，数值越小优先级越高，默认200（选填）',
  SaveAndEnable: '保存并启用',
  WANAccountPlaceholder: '请填写账号',
  WANPasswordPlaceholder: '请填写密码',
  WANWeightHelp: '您可以为每个WAN口指定权重，实现流量的负载分担，权重越高流量在每个WAN口的转发比重越大。权重相同则为平均分配。',
  WANWeightPlaceholder: '填写0~50，数值越大权重越高，默认为0（选填）',
  WANExchangeModeConfigTips: '提示：若您已配置NAT、链路高可用、策略路由并使用当前物理口。切换至交换模式后，将导致策略/配置失效。您还需要配置VLAN，并将原策略/配置修改为新配置的VLAN口。',
  LANExchangeModeConfigTips: '提示：若您已配置NAT、策略路由并使用当前物理口。切换至交换模式后，将导致策略/配置失效。您还需要配置VLAN，并将原策略/配置修改为新配置的VLAN口。',
  StartIp: '地址池起始地址',
  EndIp: '地址池结束地址',
  StartIpPlaceholder: '请填写DHCP地址池起始IP地址',
  EndIpPlaceholder: '请填写DHCP地址池结束IP地址',
  DefaultGateway: '默认网关',
  DefaultGatewayPlaceholder: '默认为当前设备网卡IP（选填）',
  Expire: '租约时间',
  ExpirePlaceholder: '请填写IP地址被占用时间，默认24小时（选填）',
  Hour: '小时',
  LANIPPlaceholder: '请填写LAN口的IP地址',
  LANNetMaskPlaceholder: '请填写LAN口的IP地址掩码',
  IPPlaceholder: '请填写IP地址',
  NetMaskPlaceholder: '请填写IP地址掩码',
  DNSName: 'DNS地址',
  DNS1Placeholder: '请填写当前设备配置的DNS地址',
  DNS2Placeholder: '请填写当前设备配置的DNS地址（备用）',
  DNS2Help: '您可以在一台设备上配置两个dns ip，默认第一个为主地址',
  SNATConfig: 'SNAT配置',
  DNATConfig: 'DNAT配置',
  SNATTips: '配置SNAT后，将内部网络地址转换为外网地址，内部网络可以通过转换后的外网地址访问外部网络，但外部网络不能通过内网转换后地址主动发起对内部网络的访问。',
  DNATTips: '配置DNAT后，将内部地址映射为外部网络地址，从而使内部网络可对外提供服务，外部网络可以通过映射后地址访问内部网络。',
  NATDeleteConfirm: '确定删除当前规则？',
  SrcIp: '内网ip', // 源ip
  SrcIpPlaceholder: '转换前的源IP地址，支持单一ip地址或ip网段',
  SrcIpSinglePlaceholder: '转换前的源IP地址，支持单一ip地址',
  DNATSrcIpSinglePlaceholder: '转换前的目标IP地址，支持单一ip地址',
  SrcIpRequire: '请填写内网IP',
  SrcIpHelp: '例：192.168.10.10 或 192.168.10.0/24',
  DestIp: '映射IP',
  DestIpRequire: '请填写映射IP',
  DestIpHelp: '例：192.168.10.10',
  MappingMode: '映射方式',
  MappingModePlaceholder: '请选择映射方式',
  DestPort: '内网端口', // 目的端口
  SrcPort: '外网端口', // 源端口
  SrcPortRequire: '请填写外网端口',
  DestPortRequire: '请填写内网端口',
  Protocol: '协议',
  ProtocolPlaceholder: '请选择协议',
  SNATRule: 'SNAT规则',
  DNATRule: 'DNAT规则',
  isNotActive: '待激活',
  Online: '在线',
  Offline: '离线',
  ActiveError: '激活失败',
  CpeIdRequire: '请选择关联设备',
  EquipmentType: '设备型号',
  PriorityisInValid: '优先级不符合要求，支持1～200，请修改',
  WeightisInValid: '权重不符合要求，支持0～50，请修改',
  CpeConfigOverview: '设备配置概览',
  CpeConfigInfo: '设备配置信息',
  NetmaskPlaceholder: '请填写子网掩码',
  DHCPIPError: 'DHCP地址池起始地址必须小于结束地址',
  ChangeTo: '更换为',
  WLANTips: '当前网关设备支持无线（Wi-Fi）功能，PC或移动设备可以通过Wi-Fi接入网络。如需接入互联网，需确保已经配置了网络地址转换',
  WLANSSIDPlaceholder: '请填写无线网络名称，支持英文数字，20个字符',
  WLANSSIDBroadcast: 'SSID广播',
  WLANSSIDBroadcastTips: '开启SSID广播后，无线设备才能搜索到该SSID名称的Wifi信号。关闭后，将隐藏wifi信号，只能通过手动输入SSID和密码连接。',
  WLANSSIDError: 'SSID仅支持大小写英文和数字',
  SafetyCertification: '安全认证',
  SafetyCertificationTips: '开启安全认证，需要设置密码。用户接入时需输入密码进行校验。\n关闭安全认证，无需密钥，任何用户都可以接入。',
  WLANIPPlaceholder: '请填写WLAN口的IP地址',
  AuthType: '认证类型',
  WIFIPassword: '无线密码',
  ConfirmPassword: '确认密码',
  WIFIPasswordPlaceholder: '设置Wifi密码，支持英文数字，8~32字符',
  WIFIConfirmPasswordPlaceholder: '确认Wifi密码，支持英文数字，8~32字符',
  WIFIPasswordError: '密码格式不符，请重新输入',
  WIFIComfirmPasswordError: '确认密码与输入密码不一致，请重新输入',
  Port: '端口',
  PortNumber: '端口编号',
  WANorLAN: 'WAN口/LAN口',
  NetsConfStatusDesc: {
    type: {
      wan: '已配置WAN口',
      lan: '已配置LAN口',
      exchange: '已配置交换口',
    },
    workMode: {
      route: '，当前为路由模式',
      exchange: '，当前为交换模式',
    },
    portMode: {
      access: '（access）',
      trunk: '（trunk）'
    },
    isForward: '，当前为流量转发端口',
    portStatus: {
      fault: '，当前物理口故障。',
      normal: '，当前物理口正常。'
    },
    options: {
      wan: '点击修改配置（为保证网关服务正常， 单条WAN口配置不支持切换、删除）',
      multiWAN: '点击修改配置或更换端口类型为LAN口',
      lan: '点击修改配置或更换端口类型为WAN口'
    }
  },
  WlanIsEnable: '已配置WLAN，当前WI-FI状态为启用，点击停用或修改配置',
  DnsModify: '已配置DNS，点击修改',
  WifiMode: '频段类型',
  WifiStatu: 'WI-FI状态',
  NotConfig: (name: string) => `未配置，点击添加${name}配置`,
  MobileDisable: '已配置，当前物理口故障，请检查sim卡及配置。点击停用或修改配置',
  MobileConnect: (level: string) => `已配置，当前信号${level}，点击停用或修改配置`,
  MobileConnectNotForwarding: (level: string) => `已配置，当前物理口正常，信号${level}，未参与流量转发。点击停用或修改配置`,
  MobileConnectIsForwarding: (level: string) => `已配置，当前为流量转发端口，信号${level}。点击停用或修改配置`,
  MobileDBLevelHigh: '强',
  MobileDBLevelGood: '良好',
  MobileDBLevelWeak: '较弱',
  MobileDBLevelWeakest: '弱',
  ConfigDisable: (name: string) => `已配置${name}，当前${name}状态为停用，点击启用或修改配置`,
  ExpireError: '租约时间最长支持168小时（7天），请修改',
  MobileConfig: '5G/4G配置',
  DialingStatus: '拨号状态',
  SubnetMask: '子网掩码',
  MobileTips: '网关设备默认不带sim卡。您需要向运营商购买一张可传输数据的sim卡。配置后系统将尝试拨号，拨号连通后可能产生费用，需向运营商支付。若暂不使用，可选择停用。',
  APNSetting: 'APN设置',
  AccesspointPlaceholder: '请输入接入点名称',
  APNSettingPlaceholder: '请输入APN配置的用户名',
  APNPasswordPlaceholder: '请输入APN配置的密码',
  DisableTitle: (title: string) => `确定停用当前设备的${title}功能？`,
  WifiExpireError: '请输入整数，最大支持168',
  WANTips: 'WAN（Wide Area Network）口为广域网端口，您可以通过该端口将您的本地网络接入白山云网络，与其他分支机构实现互通。',
  LANTips: '若您的LAN口连接的本地网络拥有较多非固定本地用户，您可开启DHCP Server动态管理、分配IP地址。如需接入互联网，需确保已经配置了网络地址转换',
  policyRouter: '策略路由',
  PolicyRouteTips: '策略路由是一种灵活的数据包路由转发机制。若您需要接入多条宽带线路，并指定线路访问特定网络，可自定义策略以确保访问特定目标的数据走对应的线路。策略路由的数据转发优先级最高。若您设置了多条策略，源目地址段存在重叠，系统默认以状态为开启且序号较小的策略优先生效。',
  GatewayBindingDevice: '网关绑定设备',
  PolicyList: '策略列表',
  PolicySwitch: '策略开关',
  PolicyName: '策略名称',
  SourceIP: '来源地址',
  TargetIP: '目标地址',
  NextHop: '下一跳',
  PolicyNamePlaceholder: '请填写，支持中英文数字下划线，限15个字符',
  PolicyNameError: '格式不符，支持中英文数字及下划线',
  PolicyLengthLimitTips: (num: number) => `一台设备最多支持创建${num}条策略，当前已达最大数量`,
  StartIPandEndIpCheck: '起始地址必须小于等于终止地址',
  NextHopError: '输入的格式错误，请填写正确的ip地址',
  DeletePolicyConfirm: '确定删除该条策略？',
  Custom: '自定义',
  DeleteMobileConfirm: '若您已设置策略路由/NAT配置/高可用配置，删除5G/4G配置将一并删除关联策略和配置。若删除后，出口链路仅有一条将会关闭链路级高可用。如有需要您可再次配置。请先确认风险并同意删除',
  DisableMobileConfirm: '若您已设置策略路由/NAT配置/高可用，停用5G/4G功能将一并删除关联策略和配置，且将不再参与流量转发，如有需要您可再次配置。请先确认风险并同意删除。',
  MoreDeleteConfirmTips: '已确认风险并同意删除关联策略路由/NAT配置/高可用配置',
  DeleteWANConfirm: '若您已设置策略路由/NAT配置/高可用配置，删除WAN口配置/更换LAN口配置将一并删除关联策略和配置，且删除后若出口链路仅有一条将会关闭链路级高可用，如有需要您可再次配置。请先确认风险并同意删除',
  WANRemarkPlaceholder: '请填写ISP或业务类型，限20字符',
  HighAvailability: '高可用配置',
  CpeHighAvailabilityTips: '设备级高可用：网关绑定多台设备且已激活，可开启高可用。设备以主备模式接入，同时在线。主设备参与流量转发，主设备故障时自动切换备设备，以保障业务不中断。',
  LinkHighAvailabilityTips: '链路级高可用：网关设备配置多出口时将自动开启链路级高可用。默认主备模式，流量转发优先选择优先级高的作为主用链路，主链路故障时自动切换至备用链路，故障恢复后自动切换回主链路，实现链路级容灾。您可以通过设置优先级或流量转发权重自定义链路转发。',
  CpeHighAvailability: '设备级高可用',
  LinkHighAvailability: '链路级高可用',
  FunctionStatus: '功能状态',
  WorkMode: '工作模式',
  CurrentFowardingCpe: '当前参与转发设备',
  CurrentFowardingLink: '当前参与转发链路',
  AvailableAndAllCpe: '可用/全部激活设备',
  AvailableAndAllLink: '可用/全部链路',
  CurrentFlowDevice: '当前流量转发设备',
  Main: '主',
  Prepare: '备',
  CpeOnlinePopover: '设备在线',
  CpeOfflinePopover: '设备离线',
  CloseHighAvailabilityTitle: '确定关闭设备级高可用',
  CloseHighAvailabilityContent: '关闭后，若当前流量转发设备发生故障时，将不会进行设备切换，可能造成业务中断',
  EditConfig: '修改配置',
  EditConfigPopover: '修改可能导致业务暂停( 5s - 10s)，请确认对业务的影响',
  FunctionStatusTips: '当前设备只配置了一条出口链路，开启链路级高可用需配置多条出口，前往',
  FunctionEmptyStatusTips: '当前设备未配置出口链路，开启链路级高可用需配置多条出口，前往',
  AllLinks: '全部链路',
  LinkPriority: '链路优先级',
  CurrentFlowLink: '当前流量转发链路',
  CurrentFlowLinkToolTips: '当前流量转发链路展示参与转发的可用链路，存在一定的回切时间延迟',
  AllLinksToolTips: '展示当前设备已配置的WAN链路和无线5G/4G链路。若未配置，可前往',
  LinkPriorityToolTips: '优先级用于表示链路主次关系。流量转发优先走主链路，主链路故障自动切换备用链路。若您设置的优先级相同，则以创建时间早的优先。',
  LinkWeightToolTips: '权重表示流量转发比重。您可以指定转发权重， 实现流量负载均衡。0表示不参与流量转发。',
  LinkDisable: '链路故障',
  LinkEnable: '链路正常',
  MobileLinkDisable: '链路故障/停用',
  LinkLabel: '链路名称',
  EquipmentTips1: '温馨提醒：网关绑定多台设备时，默认双机冷备模式，故障不自动切换。您可在高可用设置中开启',
  EquipmentTips2: '，设备同时在线，系统自动检测故障并自动切换，保障业务不中断。',
  DeviceSN: '设备License ID',
  ConfigTotalPort: '已配置/总端口数',
  SetvalueInvalid: '设置值不符合规范，请修改',
  FlowWeight: '流量转发权重',
  RepeatPriorityTips: '已存在相同优先级，流量转发将以创建时间早的优先',
  LinksDataEmpty: '当前设备未配置出口链路，前往',
  CpeFunctionStatusCloseTips: '当前网关实例只绑定了一台设备，开启设备级高可用需有2台以上的已激活设备',
  CpeFunctionStatusEmptyTips: '当前网关实例未绑定设备，开启设备级高可用需有2台以上的已激活设备',
  OtherCpe: '其他设备',
  MainCpe: '主设备',
  MainCpeAndPort: '主设备及端口',
  MainCpeAndPortTips: '请选择主设备，并为所有设备配置HA端口',
  MainCpeAndPortNeedSetTips: '请为配置缺失的设备配置HA端口',
  SureEnable: '确定开启',
  EspeciallyNotice: '特别提醒：流量转发默认选择主设备，主故障后默认切换至备设备实现数据的转发，将以备设备配置生效。 请自行确认备设备的配置（网络配置、NAT、策略路由、高可用配置）是否符合您的业务要求 。',
  CpeHighAvailabilityOpen: '设备级高可用已开启',
  CpeHighAvailabilitySuccessTips: '流量转发默认选择主设备流量，主设备故障将自动切换备设备，故障恢复后自动切回。',
  CpeHighAvailabilityEmpty: '当前网关未绑定设备，请联系客服',
  OutPort: '出接口',
  MappingOutPortExtra: '特别提示：相同设备，若添加多条相同匹配规则的配置将以创建时间早的优先生效。',
  OpenHAPort: '开启HA的端口',
  EnableFunctionPort: '开启功能的端口',
  VirtualIP: '虚拟IP',
  VirtualIPExtra: '提醒：虚IP地址必须和设备HA端口实IP在同一网段，且不能与网段内已分配IP地址冲突。',
  VirtualIPPlaceholder: '请填写虚拟IP地址，如192.168.0.2',
  HAPortloss: 'HA端口配置缺失， 请',
  CpeConfigInfoTips1: '温馨提醒：网关设备配置多出口时，系统默认以最早添加的有线链路作为主用链路，其余为备用链路。无线 5G/4G 优先级最低。 您可在',
  CpeConfigInfoTips2: '中自定义链路转发。',
  PolicyRouterDisableTips: '因对端网关设备未在线，当前链路不可用',
  PhysicalPortFailure: '物理口故障',
  PhysicalPortNormal: '物理口正常',
  CurrentSignal: '当前信号',
  HASettingLoss: '当前设备缺失，不参与流量转发及故障切换，请检查',
  MatchingRules: '匹配规则',
  MappingRules: '映射规则',
  InPort: '入接口',
  MappingPort: '映射端口',
  DestIpPlaceholder: '转换后的源IP地址，支持单一ip地址，不填则默认出接口IP',
  PortPlaceholder: '请填写单一端口，取值范围从1到65535',
  DNATDestIpPlaceholder: '请填写单一IP地址',
  NATProtocolTips: '提示：协议ALL/ICMP类型时不支持指定端口',
  MoreDisableMobileConfirmTips: '已确认风险并同意删除关联策略路由/NAT配置',
  MoreDeleteLanConfirm: '若您已设置NAT配置，删除LAN口配置/更换WAN口配置将一并删除关联配置。如有需要您可再次配置。请先确认风险并同意删除',
  MoreDeleteLanConfirmTips: '已确认风险并同意删除关联NAT配置',
  MoreDeleteVLanConfirm: '若您已设置策略路由/NAT配置/高可用，删除vlan配置将一并删除关联策略和配置或导致高可用将失效。如有需要您可再次配置。请先确认风险并同意删除',
  MoreDeleteVLanConfirmTips: '已确认风险并同意删除关联策略路由/NAT配置',
  MoreDeleteLoopBackConfirm: '若您已设置NAT配置，删除逻辑口配置将导致相关配置失效 。如有需要您可再次配置。请先确认风险并同意删除',
  MoreDeleteLoopBackConfirmTips: '已确认风险并同意删除关联NAT配置',
  OutletPort: '出口端口',
  CPENickname: '设备别名',
  EditBranchPlaceholder: '您可为网关命名，填写分支机构名称',
  BranchPlaceholder: '分支机构只支持中英文数字，限10个字符',
  AliasNameRequire: '设备别名支持中英文数字，限10个字符',
  NATSwitchTips: (title: string) =>  `若您的${title}配置用于设备接入互联网，关闭将导致无法连接上互联网`,
  DNATSwithTips: '确认关闭DNAT?',
  PolicyDeliveryStatus: '策略下发状态',
  ResultsEnforcement: '执行结果',
  PolicyDeliveryTime: '策略下发时间',
  RoutingRules: '选路规则',
  InPortErrorTips: '未设置源目地址，请设置入接口或补充源目地址匹配规则',
  ChangePriority: '调整优先级',
  SavePriority: '保存优先级',
  SrcDestIpErrorTips: '源目地址不能同时设置为any（0.0.0.0-255.255.255.255或放空），请补充',
  PolicyStatusTips1: (num: number) => `全部成功下发，共${num}条，全部执行成功`,
  PolicyStatusTips2: (num: number, detail: string) => `成功下发${num}条，因${detail}，执行中断。修改后或关闭该策略将重新执行下发动作。`,
  PolicyStatusTips3: '成功下发0条，未成功执行，请重新编辑提交或重新开关以触发重新下发',
  ExecutionStatus: '执行状态',
  DiagnosticTools: '诊断工具',
  NetworkDetection: '网络检测',
  NetworkDetectionTips: '通过ping (Packet Internet Groper)命令用以测试网络连接量。您可使用命令，检查网络是否通畅或者网络连接速度。',
  NetworkSpeedTest: '网络测速',
  NetworkSpeedTestTips: '测速工具Speedtest支持统计带宽速率、延迟、数据包丢失等信息。您可用于公网网络性能评估，定位问题，解决网络故障。',
  LinkProbe: '链路探测',
  LinkProbeTips: '探测工具iperf支持统计链路质量指标数据信息。您可用于测试到目标对端的网络性能，定位问题，解决网络故障。',
  CommonParameters: '常用参数',
  TargetIPPlaceholder: '请输入域名/IP地址',
  NumberOfPackages: '发包个数',
  NumberOfPackagesPlaceholder: '请填写1-100的正整数，不填则默认5',
  ResultExecution: '执行结果',
  NetworkExit: '网络出口',
  NetworkExitTips: '特别提示：建议选择业务空闲时段进行测速。否则可能因占用带宽而影响网络服务。',
  TargetPeer: '目标对端',
  RequestError: '请求失败，未能成功执行',
  BandwidthRate: '带宽速率',
  Upload: '上传',
  Download: '下载',
  NetworkQuality: '网络质量',
  ReasonForFailure: '失败原因',
  OutletPortExtra: (portName: string) => `特别提示：当前CPE的开局端口为【${portName}】，出口端口请避开选择开局端口，以免开局失败。`,
  NetworkModule: '网络模块',
  GatewayPlaceholder: '请填写网关ip',
  NetType: '网络类型',
  VlanNetTypeExtra: '提示：若您已配置NAT、策略路由、高可用并使用当前逻辑口。切换网络类型后，可能将导致策略/配置失效。如有必要建议先修改关联策略再进行逻辑口修改。',
  DefaultDNS: '默认DNS',
  PrivateDNS: '私网DNS',
  PrivateDomainName: '私网域名',
  PrivateDNS2Extra: '提示：默认第一个为主地址，若放空不填将按照默认配置保存。默认配置：主DNS  119.29.29.29，备DNS 114.114.114.114 。',
  PrivateDomainNameExtra: '请填写域名，支持多个，一个一行，最多300个。支持泛域名，格式：.domain.com',
  PrivateDomainError: '最多支持300个域名，一个一行，请按要求修改',
  PrivateDNSErrorTips: '若您需要配置私网DNS，请填写DNS地址和私网域名',
  DNSAlertTips: '您可以为设备配置默认DNS和私网DNS，支持配置主备两个地址。流量未匹配的私网域名，统一按照默认DNS解析。',
  MTUPlaceholder: '请填写68-1500的正整数，不填默认1500',
  MTUPlaceholder2: '请填写128-1492的正整数，不填默认1492',
  MSSPlaceholder: '请填写500-1460的正整数，不填默认1460',
  MSSPlaceholder2: '请填写500-1452的正整数，不填默认1452',
  MaxLengthErrorTips: (name: string, num: number) => `当前设备的${name}配置数量已达上限${num}条`,
  forwardMax: '最大转发数',
  forwardMaxPlaceholder: '请填写大于150的正整数，不填默认150',
  Static: '静态',
  StaticAddress: '静态地址',
  DHCPConfigTips: '已配置DHCP静态地址，您可在下方DHCP分配表查看分配详情',
  ClientIP: '客户端IP',
  ClientMAC: '客户端MAC',
  PleaseFillInMACAddress: '请填写MAC地址',
  AllocationResult: '分配结果',
}